// extracted by mini-css-extract-plugin
export default {"input":"styles_input__PxAm+","label":"styles_label__GtDv2"};